export const ItemTypes = {
  BulletinBoardItem: 'bulletin-bord-item',
}
